import { IncidentTypeMapArr } from './config';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import colors from '@/styles/color.scss';
import { spaceTimeType, trafficType } from '@blade/common/pages/result-details/common/config';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
export const getTaskTargetStr = (input, output, str) => {
    const target = IncidentTypeMapArr.find((item) => item[input] === str);
    return target?.[output] || '';
};
const option = {
    normal: {
        fillStyle: colors.polygonFillStyle,
        lineWidth: 2,
        strokeStyle: colors.polygonStrokeStyle,
    },
};
const optionHeadRect = {
    normal: {
        fillStyle: colors.boardLevelMinorColor,
        strokeStyle: colors.boardLevelMinorColor,
        lineWidth: 2,
        globalAlpha: 0,
    },
};
const optionRect = {
    normal: {
        fillStyle: 'transparent',
        strokeStyle: colors.textCritica,
        lineWidth: 2,
        globalAlpha: 1,
    },
};
let polygonData = [];
// 人脸比中
export function changeIndex(data, type, detailsType, headPointStatus, name) {
    polygonData = [];
    const version = data?.imageFeature?.version || data?.version;
    const featureValue = data?.imageFeature?.featureValue || data?.featureValue;
    console.log('data', data, type, detailsType, headPointStatus);
    if (headPointStatus) {
        switch (detailsType) {
            case 'FACE_MATCH':
                setFacePolygonData(data.faceAnnotation?.personGroups, type, name);
                break;
            case 'FACE_PEDESTRIAN':
                setFacePolygonData(data.pedestrianAnnotation?.personGroups, type, name);
                break;
            case 'INCIDENT_FACE_UNMATCHED':
                setFacePolygonData(data.faceAnnotation?.personGroups, type, name);
                break;
            case 'OBJECT_FACE':
                setFacePolygonData(data.portraitImageInPanoramics, detailsType, name, data.portraitExpandImageInPanoramics);
                break;
            case 'OBJECT_PEDESTRIAN':
                setFacePolygonData(data.portraitImageInPanoramics, detailsType, name, data.portraitExpandImageInPanoramics);
                break;
            case 'EVENT_FACE':
                setFacePolygonData(data.portraitImageInPanoramics, detailsType, name, data.portraitExpandImageInPanoramics);
                break;
            case 'Everything':
                setFacePolygonData(data.portraitImageInPanoramics, detailsType, name, data.portraitExpandImageInPanoramics);
                break;
            case 'FILECLUSTER_FACE':
                setFacePolygonData(data.personGroups, detailsType, name);
                break;
            case 'OBJECT':
                setFacePolygonData(data.objectsDetectionAnnotation.groups, detailsType, name);
                break;
        }
    }
    else {
        polygonData = [];
    }
    // 添加版本
    polygonData.forEach((item) => {
        if (!item['version'])
            item['version'] = version;
        if (!item['featureValue'])
            item['featureValue'] = featureValue;
    });
    return polygonData;
}
function setFacePolygonData(Array, detailsType, name, data) {
    if (spaceTimeType.includes(detailsType)) {
        setReactTime(Array, data);
    }
    else {
        Array?.forEach((item) => {
            const persons = item?.targets;
            if (persons && persons.length) {
                setReact(persons, name);
            }
        });
    }
}
export function getRoiData(data, type, detailsType, name, modelType) {
    polygonData = [];
    let roi = [];
    if (data?.crowdAnnotation) {
        roi = JSON.parse(JSON.stringify(data.crowdAnnotation?.rois));
    }
    if (data?.commonAnnotation) {
        roi = JSON.parse(JSON.stringify(data.commonAnnotation?.rois));
    }
    if (data?.trafficAnnotation) {
        roi = JSON.parse(JSON.stringify(data.trafficAnnotation?.rois));
    }
    // 搜索中心数据
    if (data?.portraitImageInPanoramics) {
        roi = JSON.parse(JSON.stringify(data.portraitImageInPanoramics));
    }
    if (data?.objectsDetectionAnnotation) {
        roi = JSON.parse(JSON.stringify(data?.objectsDetectionAnnotation?.rois));
    }
    if (data?.everythingAnnotation) {
        roi = JSON.parse(JSON.stringify(data?.everythingAnnotation?.rois));
    }
    if (roi?.length) {
        roi.forEach((item, index) => {
            item.status = 'end';
            item.type = 'polygon';
            item.name = `ROI-0${index + 1}`;
            item.showName = true;
            item.options = option;
            item.vertices.unshift(item.vertices[item.vertices.length - 1]);
        });
        polygonData = JSON.parse(JSON.stringify(roi));
    }
    const { taskConsist, deviceId } = data || {};
    const taskId = taskConsist?.taskId;
    switch (type) {
        case 'Crowd':
            switch (detailsType) {
                // 离岗
                case 'INCIDENT_OFF_DUTY':
                    let localHeadPoint = [];
                    const persons = data.crowdAnnotation?.crowdSubGroups;
                    if (persons && persons.length) {
                        persons.forEach((item) => {
                            if (item.persons) {
                                localHeadPoint = item.persons.map((item) => {
                                    return item.rectangle;
                                });
                            }
                        });
                        localHeadPoint.forEach((item) => {
                            const obj = {
                                status: 'end',
                                type: 'rect',
                                options: optionHeadRect,
                                vertices: item.vertices,
                            };
                            polygonData.push(obj);
                        });
                    }
                    break;
                case 'INCIDENT_QUEUE_TIMING':
                    AlarmDetailsModule.getRoiDataMap({ taskId, deviceId }).then((res) => {
                        polygonData.push(res);
                    });
                    // 排队时长
                    break;
                // 排队人数
                case 'INCIDENT_QUEUE_COUNTING':
                    AlarmDetailsModule.getRoiDataMap({ taskId, deviceId }).then((res) => {
                        polygonData.push(res);
                    });
                    break;
                // 人数逆流
                case 'INCIDENT_RETROGRADE':
                    if (roi.length) {
                        if (data.crowdAnnotation?.directionVertices) {
                            const directionsObj = {
                                status: 'end',
                                type: 'arrow',
                                options: setCustomOptions('arrow'),
                                vertices: data.crowdAnnotation?.directionVertices || [],
                            };
                            polygonData.push(directionsObj);
                        }
                    }
                    break;
                // 跨线
                case 'INCIDENT_CROSS_LINE':
                    getIncidentCrossLine(data);
                    break;
                // 人群统计
                case 'INCIDENT_CROWD':
                    if (modelType === 'HEAD_SHOULDER') {
                        data.crowdAnnotation?.crowdSubGroups?.forEach((item) => {
                            const persons = item?.targets;
                            if (persons && persons.length) {
                                setReact(persons);
                            }
                        });
                    }
            }
            break;
        case 'Waste':
            setFacePolygonData(data.commonAnnotation?.groups, detailsType, name);
            break;
        case 'Conduct':
            setFacePolygonData(data.commonAnnotation?.groups, detailsType, name);
            break;
        case 'Pavement':
            setFacePolygonData(data.commonAnnotation?.groups, detailsType, name);
            break;
        case 'Abnormal':
            setFacePolygonData(data.commonAnnotation?.groups, detailsType, name);
            break;
        case 'Traffic':
            getTraffic(data, detailsType, name);
            break;
        case 'Object':
            data?.objectsDetectionAnnotation?.groups.forEach((item) => {
                const persons = item?.targets;
                if (persons && persons.length) {
                    setReact(persons);
                }
            });
            break;
    }
    return polygonData;
}
function getIncidentCrossLine(data) {
    const lineObj = {
        options: setCustomOptions('line'),
        status: 'end',
        type: 'line',
        vertices: data.crowdAnnotation.crossLineVertices,
    };
    polygonData.push(lineObj);
}
export function setReact(persons, name) {
    persons.forEach((item1) => {
        const rectObj = {
            status: 'end',
            type: 'rect',
            name: name,
            showName: true,
            options: optionRect,
            vertices: item1.rectangle.vertices,
            verticesData: item1.imageRectangle.vertices,
        };
        polygonData.push(rectObj);
    });
}
// 搜索中心时空
function setReactTime(persons, data) {
    persons?.forEach((item1) => {
        const rectObj = {
            ...item1,
            status: 'end',
            type: 'rect',
            name: '',
            showName: true,
            options: optionRect,
            vertices: item1.vertices,
            verticesData: data?.[0]?.vertices,
        };
        polygonData.push(rectObj);
    });
}
// 人头点获取
export function getLocalHeadPoint(data, type, detailsType, modelType) {
    let headPoint = [];
    if (type === 'Crowd') {
        switch (detailsType) {
            case 'INCIDENT_OFF_DUTY':
                headPoint = [];
                break;
            case 'INCIDENT_CROWD':
                if (modelType === 'HEAD_SHOULDER') {
                    headPoint = [];
                }
                else {
                    let localHeadPoint = {};
                    data.crowdSubGroups?.forEach((item) => {
                        const persons = item?.targets;
                        if (persons && persons.length) {
                            persons.forEach((personItem) => {
                                localHeadPoint = personItem.coordinate;
                                headPoint.push(localHeadPoint);
                            });
                        }
                    });
                }
                break;
            default:
                let localHeadPoint = {};
                data.crowdSubGroups?.forEach((item) => {
                    const persons = item?.targets;
                    if (persons && persons.length) {
                        persons.forEach((personItem) => {
                            localHeadPoint = personItem.coordinate;
                            headPoint.push(localHeadPoint);
                        });
                    }
                });
        }
    }
    return headPoint;
}
// 交通任务
async function getTraffic(data, detailsType, name) {
    if (trafficType.includes(detailsType)) {
        const newArrayData = await getDirectionRoiMappingsToRoiData(JSON.parse(data.trafficAnnotation?.directionRoiMappings));
        polygonData.push(...newArrayData);
        data.trafficAnnotation?.groups.forEach((item) => {
            const persons = item?.targets;
            if (persons && persons.length) {
                setReact(persons, name);
            }
        });
    }
    else {
        data.trafficAnnotation?.groups.forEach((item) => {
            const persons = item?.targets;
            if (persons && persons.length) {
                setReact(persons, name);
            }
        });
    }
}
function getDirectionRoiMappingsToRoiData(directionRoiMappings) {
    const newRoiData = [];
    directionRoiMappings.forEach((item, index) => {
        const newPolygonData = {
            id: item.rawRoi.name + index,
            options: {
                hover: {
                    fillStyle: colors.polygonFillStyleHover,
                    lineWidth: 4,
                    strokeStyle: colors.polygonStrokeStyle,
                },
                normal: {
                    fillStyle: colors.polygonFillStyle,
                    lineWidth: 2,
                    strokeStyle: colors.polygonStrokeStyle,
                },
            },
            status: 'end',
            type: 'polygon',
            vertices: getArrVertices(item.rawRoi.vertices),
        };
        if (item?.directions && item?.directions.length !== 0) {
            const newArrowData = {
                id: item.rawRoi.name,
                options: {
                    hover: {
                        fillStyle: colors.lineFillStyle,
                        globalAlpha: 0.8,
                        lineWidth: 4,
                        strokeStyle: colors.white,
                    },
                    normal: {
                        fillStyle: colors.lineFillStyle,
                        globalAlpha: 0.3,
                        lineWidth: 2,
                        strokeStyle: colors.white,
                    },
                },
                status: 'end',
                type: 'arrow',
                vertices: [...item?.directions],
            };
            newRoiData.push(newArrowData);
        }
        newRoiData.push(newPolygonData);
    });
    return newRoiData;
}
function getArrVertices(array) {
    const newArray = [...array];
    newArray.unshift(array[array.length - 1]);
    return newArray;
}
